import {Component, Input} from '@angular/core';
import {UserEntity} from '@app/shared/services/api/user-entity';
import {AppConstants} from '@app/shared/util/app-constants';

@Component({
  selector: 'app-show-user-entity-logo',
  templateUrl: './show-user-entity-logo.component.html',
  styleUrls: ['./show-user-entity-logo.component.scss'],
  standalone: false
})
export class ShowUserEntityLogoComponent {

  @Input() entity: UserEntity;
  @Input() fontSize = AppConstants.DEFAULT_LOGO_FONT_SIZE;

  constructor() { }
}
